import { EventSearchDefaults } from "./enums";

/**
 * Formats an age range for display.
 *
 * The age slider is bounded by EventSearchDefaults.MinAge/MaxAge, so a
 * bound-hugging edge is open-ended: the bottom end reads "and Under" and the
 * top end reads "and Up".
 *
 * Examples: "All ages" (0-65), "Ages 10 and Under" (0-10),
 * "Ages 21 and Up" (21-65), "Age 18" (18-18), "Ages 18 to 30".
 */
export const formatAgeRange = (min?: number, max?: number): string => {
  if (min === undefined && max === undefined) return "All ages";

  const isMinOpen = min === undefined || min === null || min <= EventSearchDefaults.MinAge;
  const isMaxOpen = max === undefined || max === null || max >= EventSearchDefaults.MaxAge;

  if (isMinOpen && isMaxOpen) return "All ages";
  if (isMinOpen) return `Ages ${max} and Under`;
  if (isMaxOpen) return `Ages ${min} and Up`;
  if (min === max) return `Age ${min}`;
  return `Ages ${min} to ${max}`;
};
